<template>
  <div class="vx-card" id="individual">
    <div class="vx-card__body card-body">
      <form v-if="!loading">
        <div class="vx-row mb-2">
          <div class="vx-col lg:w-1/4 sm:w-1/3 w-full">
            <vs-input
              class="inputx mb-2 mt-1"
              v-model="individualInfo.firstname"
              name="fName"
              :label="$t('Firstname')"
              readonly="readonly"
              v-validate="'required'"
            />
            <span class="text-danger text-sm" v-show="errors.has('fName')">{{
              errors.first("fName")
            }}</span>
          </div>
          <div class="vx-col lg:w-1/4 sm:w-1/3 w-full">
            <vs-input
              class="inputx mb-2 mt-1"
              v-model="individualInfo.lastname"
              name="lName"
              :label="$t('Lastname')"
              readonly="readonly"
              v-validate="'required'"
            />
            <span class="text-danger text-sm" v-show="errors.has('lName')">{{
              errors.first("lName")
            }}</span>
          </div>
          <div class="vx-col lg:w-1/4 sm:w-1/3 w-full">
            <vs-input
              class="inputx mb-2 mt-1"
              v-model="individualInfo.socialSecurityNumber"
              name="idNumber"
              :label="$t('SocialSecurityNumber')"
              readonly="readonly"
              v-validate="{
                regex: '^([0-9]+)$',
                required: 'true',
                digits: '10'
              }"
            />
            <span class="text-danger text-sm" v-show="errors.has('idNumber')">{{
              errors.first("idNumber")
            }}</span>
          </div>
          <div class="vx-col lg:w-1/4 sm:w-1/3 w-full">
            <vs-input
              class="inputx mb-2 mt-1"
              v-model="individualInfo.birthCertificateNumber"
              name="certificateNumber"
              :label="$t('BirthCertificateNumber')"
              readonly="readonly"
              v-validate="{ regex: '^([0-9]+)$', required: 'true' }"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('certificateNumber')"
              >{{ errors.first("certificateNumber") }}</span
            >
          </div>
        </div>
        <div class="vx-row  mb-2">
          <div class="vx-col lg:w-1/4 sm:w-1/3 w-full">
            <vs-input
              class="inputx mb-2 mt-1"
              v-model="individualInfo.email"
              name="email"
              v-validate="'email'"
              readonly="readonly"
              :label="$t('Email')"
            />
            <span class="text-danger text-sm" v-show="errors.has('email')">{{
              errors.first("email")
            }}</span>
          </div>
          <div class="vx-col lg:w-1/4 sm:w-1/3 w-full">
            <vs-input
              class="inputx mb-2 mt-1"
              v-for="phone in individualInfo.customerPhonesQuery"
              :key="phone.id"
              v-model="phone.area"
              name="area"
              v-validate="{ regex: '^([0-9]+)$' }"
              readonly="readonly"
              :label="$t('PhoneArea')"
            />
            <span class="text-danger text-sm" v-show="errors.has('area')">{{
              errors.first("area")
            }}</span>
          </div>
          <div class="vx-col lg:w-1/4 sm:w-1/3 w-full">
            <vs-input
              class="inputx mb-2 mt-1"
              v-for="phone in individualInfo.customerPhonesQuery"
              :key="phone.id"
              v-model="phone.number"
              name="number"
              v-validate="{ regex: '^([0-9]+)$' }"
              readonly="readonly"
              :label="$t('PhoneNumber')"
            />
            <span class="text-danger text-sm" v-show="errors.has('number')">{{
              errors.first("number")
            }}</span>
          </div>
          <!--<div class="vx-col lg:w-1/4 sm:w-1/3 w-full">
            <vs-input class="inputx mb-2 mt-1"
                      v-for="address in individualInfo.customerAddressesInfoQuery"
                      v-model="address.postalCode"
                      name="postalCode"
                      v-validate="{regex: '^([0-9]+)$',digits:'10'}"
                      :label="$t('PostalCode')" />
            <span class="text-danger text-sm" v-show="errors.has('postalCode')">{{ errors.first('postalCode') }}</span>
          </div>-->
        </div>
        <!--<div class="vx-row mb-2">
          <div class="vx-col  w-full">
            <vs-input class="inputx mb-2 mt-1"
                      v-for="address in individualInfo.customerAddressesInfoQuery"
                      v-model="address.address"
                      name="address"
                      :label="$t('Address')" />
          </div>
        </div>-->
        <!--<div class="vx-row">
          <div class="vx-col  w-full">
            <vs-button type="filled" class="float-right submit-btn" @click.prevent="submitForm()" :disabled="disabled">{{$t('Save')}}</vs-button>
          </div>
        </div>-->
      </form>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { Validator } from "vee-validate";
const dict = {
  custom: {
    fName: {
      required: "لطفا نام را وارد نمایید."
    },
    lName: {
      required: "لطفا نام خانوادگی را وارد نمایید."
    },
    idNumber: {
      required: "لطفا کدملی را وارد نمایید.",
      regex: "کدملی نامعتبر می باشد",
      digits: "کدملی نامعتبر می باشد"
    },
    certificateNumber: {
      required: "لطفا شماره شناسنامه را وارد نمایید.",
      regex: "شماره شناسنامه نامعتبر می باشد"
    },
    email: {
      email: "پست الکترونیک نامعتبر می باشد."
    },
    area: {
      regex: "پیش شماره نامعتبر می باشد."
    },
    number: {
      regex: "شماره تلفن نامعتبر می باشد."
    },
    postalCode: {
      regex: "کدپستی نامعتبر می باشد.",
      digits: "کدپستی نامعتبر می باشد."
    }
  }
};
Validator.localize("fa", dict);
export default {
  data() {
    return {
      individualInfo: {},
      disabled: false
    };
  },
  mounted() {
    this.load();
  },
  computed: {
    ...mapGetters({
      individual: "individual/details",
      loading: "individual/loading"
    })
  },
  methods: {
    ...mapActions({
      fetchSingleIndividual: "individual/fetchSingle",
      updateIndividual: "individual/update"
    }),
    load() {
      var id = this.$route.params.id;
      this.fetchSingleIndividual(id).then(() => {
        this.individualInfo = Object.assign({}, this.individual);
      });
    },
    submitForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.disabled = true;
          this.individualInfo.customerId = this.individualInfo.id;
          this.individualInfo.customerProvinceInfoCommand = this.individualInfo.customerProvinceQuery;
          this.individualInfo.customerAddressesInfoCommand = this.individualInfo.customerAddressesInfoQuery;
          this.individualInfo.customerPhonesCommand = this.individualInfo.customerPhonesQuery;
          this.individualInfo.emailAddress = this.individualInfo.email;
          this.individualInfo.customerOwner = this.individualInfo.owner;
          this.updateIndividual(this.individualInfo).then(() => {
            this.$swal({
              position: "center-center",
              type: "success",
              text: "رکورد مورد‌نظر با موفقیت ویرایش شد!",
              showConfirmButton: false,
              timer: 2000
            }).then(() => {
              this.$router.push("/Customers/Index");
            });
            this.$validator.reset();
          });
        } else {
          // form have errors
        }
      });
    }
  }
};
</script>
